<template>
	<div>
		<b-modal id="modal-lg" ref="update-kickback" size="lg" hide-footer :title="$t('message.EDIT_KICKBACK')" :no-close-on-backdrop="true" style="margin-top:-66px !important">
			<div class="row">
				<div class="col-md-6">
					<label class="label">{{ $t('message.ENSURE') }} (%)</label>
                    <input name="ensure" v-model="ensure" type="number" min='0' class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('ensure') }" autocomplete="off"> 
                    <span v-show="errors.has('ensure')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6">
					<label class="label">{{ $t('message.DANTAXI') }} (%)</label>
                    <input name="dantaxi" v-model="dantaxi" type="number" min='0' class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('dantaxi') }" autocomplete="off"> 
                    <span v-show="errors.has('dantaxi')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
            </div>
			<br />
			<hr> <span class="float-right">
        <b-button class="btn btn-info mr-2"   @click="update_kickback()">{{ $t("message.UPDATE")}}</b-button>
        <b-button class=" btn btn-danger"   @click="$bvModal.hide('modal-lg')">{{ $t("message.CLOSE")}}</b-button>
        </span> </b-modal>
	</div>
</template>
<script>

export default {
    data () {
      return {
          ensure:'',
          dantaxi:'',
          price_id:'',
      }
    },

    methods:{
        async update_kickback(){
            const valid = await this.$validator.validateAll()
            if (valid) {
                
                let form_data = {
                    price_id: this.price_id,
                    ensure: this.ensure,
                    dantaxi: this.dantaxi,
                }

                let loader = this.$loading.show()

                try 
                {
                    const data_obj = await this.$store.dispatch('admin_price/update_kickback', form_data)
                    this.$store.dispatch("notifications_alert/success", this.$t('message.MSG_UPDATE_SUCC'))
                    this.$refs['update-kickback'].hide()
                    loader.hide()

                } 
                catch (e) 
                {
                    loader.hide()
                    this.$store.dispatch("notifications_alert/error", e.response.data.message)
                }
            }
        },
        show(price_id,ensure, dantaxi)
        {
            this.price_id = price_id
            
            this.ensure = ensure,
            this.dantaxi = dantaxi,
            this.$refs['update-kickback'].show()
            
        }
    }
}
</script>
<style >
.modal.show .modal-dialog{
    margin-top: -75px !important;
}
</style>